module.exports = __webpack_public_path__ + "img/class-badge.754092ab.png";